import { render, staticRenderFns } from "./Friendship.vue?vue&type=template&id=6944e038&scoped=true"
import script from "./Friendship.vue?vue&type=script&lang=js"
export * from "./Friendship.vue?vue&type=script&lang=js"
import style0 from "./Friendship.vue?vue&type=style&index=0&id=6944e038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6944e038",
  null
  
)

export default component.exports